<section class="wrapper">
    <form [formGroup]="accessForm">
        <header>
            <div class="breadcrumb">
                <span class="icon icon-caret-left"></span>
                <div class="breadcrumb-link" (click)="goBack()">
                    <span>{{ 'access_control.form.back' | translate }}</span>
                </div>
            </div>
            <h1> {{ title }}</h1>
        </header>
        <section class="content loading" *ngIf="loading">
            <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
        </section>
        <section class="content">
            <div class="section-content section-general-information">
                <!-- New wrapper for side-by-side layout -->
                <div class="top-section-row">
                    <!-- Left column containing translation inputs and title -->
                    <div class="left-column">
                        <div class="translation-inputs-name">
                            <div *ngFor="let language of langs" class="lang-input-wrapper" formGroupName="title">
                                <div class="combine">
                                    <span class="title_section">{{ 'access_control.form.role_name.' + language | translate }}</span><span class="red">{{ 'access_control.form.asterix' | translate }}</span>
                                </div>
                                <app-form-input
                                    class="custom-form-input"
                                    [placeholder]="'access_control.form.role_name_placeholder' | translate"
                                    [formControlName]="language"
                                >
                                    <app-form-error *ngIf="nameForm.get(language).touched && nameForm.get(language).hasError('required')">
                                        {{ 'access_control.form.error' | translate }}
                                    </app-form-error>
                                </app-form-input>
                            </div>
                        </div>

                        <div *ngFor="let language of langs" class="lang-input-wrapper" formGroupName="description">
                                <div class="combine">
                                    <span class="title_section">{{ 'access_control.form.role_description.' + language | translate }}</span><span class="red">{{ 'access_control.form.asterix' | translate }}</span>
                                </div>
                                <app-form-input
                                    class="custom-form-input"
                                    [placeholder]="'access_control.form.role_description_placeholder' | translate"
                                    [formControlName]="language"
                                >
                                    <app-form-error *ngIf="descriptionForm.get(language).touched && descriptionForm.get(language).hasError('required')">
                                        {{ 'access_control.form.error' | translate }}
                                    </app-form-error>
                                </app-form-input>
                        </div>
                        
                        <div class="title">
                            <span class="title_section_middle">{{ 'access_control.form.select_modules' | translate }}</span>
                            <p class="sub_title">{{ 'access_control.form.select_modules_description' | translate }}</p>
                            <div class="select-modules" *ngFor="let module of modules">
                                <app-toggle-switch 
                                    [label]="module.label"
                                    [accessForm]="accessForm"
                                    [isEdited]="isEditMode"
                                    [FormName]="module.value">
                                </app-toggle-switch>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Right column containing configured modules -->
                    <div class="configured-modules">
                        <span class="title_section_middle">{{ 'access_control.form.configured_modules.title' | translate }}</span>
                        <p *ngIf="!checkActiveModules()">{{ 'access_control.form.configured_modules.no_modules' | translate }}</p>
                        <div *ngFor="let module of modules">
                            <app-access-control-banner
                                [formGroup]="accessForm" 
                                [formName]="module.value"
                                [label]="module.label"
                            ></app-access-control-banner>
                        </div>
                    </div>
                </div>

                <!-- Mobile version of configured modules -->
                <div class="configured-modules-bottom" >
                    <span class="title_section_middle">{{ 'access_control.form.configured_modules.title' | translate }}</span>
                    <p *ngIf="!checkActiveModules()">{{ 'access_control.form.configured_modules.no_modules' | translate }}</p>
                    <div *ngFor="let module of modules">
                        <app-access-control-banner [formGroup]="accessForm" [formName]="module.value" [label]="module.label"></app-access-control-banner>
                    </div>
                </div>
                
                <div class="row action-button">
                    <button
                    *ngIf="isEditMode"
                        (click)="goBack()"
                        class="bciti-button bciti-button--black-inversed action-button" 
                        [disabled]="submitLoading">
                            <mat-progress-spinner
                                *ngIf="submitLoading"
                                mode="indeterminate" 
                                diameter="20"
                            ></mat-progress-spinner>
                            <span  *ngIf="!submitLoading">
                                {{ 'access_control.form.cancel' | translate }}
                            </span>
                    </button>
                    <button
                        (click)="saveRole()"
                        class="bciti-button bciti-button--black action-button" 
                        [disabled]="submitLoading || !accessForm.valid">
                            <mat-progress-spinner
                                *ngIf="submitLoading"
                                mode="indeterminate" 
                                diameter="20"
                            ></mat-progress-spinner>
                            <span  *ngIf="!submitLoading && !isEditMode">
                                {{ 'access_control.form.create' | translate }}
                            </span>
                            <span  *ngIf="!submitLoading && isEditMode">
                                {{ 'access_control.form.edit' | translate }}
                            </span>
                    </button>
                </div>
            </div>
        </section>
    </form>
</section>